import { render, staticRenderFns } from "./AllocationCollectOffline.vue?vue&type=template&id=74ca1e18&scoped=true"
import script from "./AllocationCollectOffline.vue?vue&type=script&lang=js"
export * from "./AllocationCollectOffline.vue?vue&type=script&lang=js"
import style0 from "./AllocationCollectOffline.vue?vue&type=style&index=0&id=74ca1e18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ca1e18",
  null
  
)

export default component.exports